import {CSSProperties, FC} from 'react';


export interface IIconWheelBackProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconWheelBack: FC<IIconWheelBackProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M16.308 8.273h1.077c.89 0 1.615-.71 1.615-1.582V4.582C19 3.71 18.275 3 17.385 3h-1.077c-.891 0-1.616.71-1.616 1.582v.527h-1.176A1.617 1.617 0 0 0 12 4.075c-.694 0-1.288.431-1.516 1.034H9.308v-.527C9.308 3.71 8.583 3 7.692 3H6.615C5.725 3 5 3.71 5 4.582v2.11c0 .872.725 1.581 1.615 1.581h1.077c.891 0 1.616-.71 1.616-1.582v-.527h1.162c.16.458.527.823.992.984v9.744a1.607 1.607 0 0 0-.978.944H9.308v-.527c0-.873-.725-1.582-1.616-1.582H6.615c-.89 0-1.615.71-1.615 1.582v2.109C5 20.29 5.725 21 6.615 21h1.077c.891 0 1.616-.71 1.616-1.582v-.527h1.162c.217.624.82 1.074 1.53 1.074.71 0 1.313-.45 1.53-1.074h1.162v.527c0 .872.725 1.582 1.616 1.582h1.077c.89 0 1.615-.71 1.615-1.582v-2.11c0-.872-.725-1.581-1.615-1.581h-1.077c-.891 0-1.616.71-1.616 1.582v.527h-1.176a1.608 1.608 0 0 0-.977-.944V7.148c.465-.162.832-.526.99-.984h1.163v.527c0 .873.725 1.582 1.616 1.582ZM8.23 6.691c0 .291-.242.528-.539.528H6.615a.534.534 0 0 1-.538-.528V4.582c0-.29.241-.527.538-.527h1.077c.297 0 .539.236.539.527v2.11ZM12 5.13c.297 0 .539.237.539.528 0 .29-.242.527-.539.527a.534.534 0 0 1-.539-.527c0-.291.242-.528.539-.528Zm0 13.782a.534.534 0 0 1-.539-.528c0-.29.242-.527.539-.527.297 0 .539.236.539.527 0 .291-.242.528-.539.528Zm3.77-14.329c0-.29.24-.527.538-.527h1.077c.296 0 .538.236.538.527v2.11c0 .29-.241.527-.538.527h-1.077a.534.534 0 0 1-.539-.528V4.582Z" />
        </svg>
    );
};
